import * as React from 'react';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import { observer } from 'mobx-react';
import { ChangePlanModalLayout } from './ChangePlanModalLayout';
import { Modal } from '@wix/design-system';

interface ChangePlanModalProps {
  rootStore: RootStore;
}

const ChangePlanModalComp: React.FC<ChangePlanModalProps> = ({ rootStore }) => {
  const { changePlanModalOpened } = rootStore.appStore;

  return (
    <Modal isOpen={changePlanModalOpened} dataHook='change-plan-modal'>
      {changePlanModalOpened && <ChangePlanModalLayout />}
    </Modal>
  );
};

export const ChangePlanModal = withInjectedRootStore(
  observer(ChangePlanModalComp),
);
